import { useEffect, useState } from 'react';
import { randomNumber } from '../util/numbers';

/**
 * useAnimateIndex
 * @param arg The array to pick a random index from.
 * @param time (Optional) Time in milliseconds to refresh the index. Defaults to 5000.
 * @returns Random index from the array.
 */
export const useAnimateIndex = <T extends unknown>(arg: Array<T>, time = 5000): [ animateIndex: number | null ] => {
  const [ animateIndex, setAnimateIndex ] = useState<number | null>(null);

  useEffect(() => {
    let int: NodeJS.Timeout;
    if (arg.length) {
      int = setInterval(() => setAnimateIndex(randomNumber(0, arg.length - 1, true)), time);
    }
    return () => clearInterval(int);
  }, [ arg, time ]);


  return [ animateIndex ];
};
